export enum ReligionEnum {
    NONE = 1,
    CATHOLIC = 2,
    PROTESTANT = 3,
    JUDAISM = 4,
    ISLAM = 5,
    BUDDHISM = 6,
    OTHER = 7
}